import { render } from "./Solicitantes-App.vue?vue&type=template&id=256891b4&scoped=true"
import script from "./Solicitantes-App.vue?vue&type=script&lang=js"
export * from "./Solicitantes-App.vue?vue&type=script&lang=js"

import "./Solicitantes-App.vue?vue&type=style&index=0&id=256891b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-256891b4"]])

export default __exports__